function Footer() {
  return (
    <footer className="footer">
      <p style={{ fontWeight: 'bold', color: '#fff', marginBottom: '10px' }}>REHOBOTH BUILDERS</p>
      <p>© 2026 · All Rights Reserved · Crafted for Excellence</p>
    </footer>
  );
}

export default Footer;